module.exports = __webpack_public_path__ + "static/img/icon_zoom_out.42f1bd06.svg";